import $ from 'jquery';

export default class ShareThis {
  constructor(el, boundingEl = null) {
    this.el = el;
    this.boundingEl = boundingEl;
    this.$el = $(this.el);

    if (!this.el) {
      throw new Error('Cannot find ShareThis element.');
    }

    this.modal = this.el.nextElementSibling;
    this.$modal = $(this.modal);

    this.isVisible = this.$modal.revealer('isVisible');

    if (!this.modal) {
      throw new Error('Cannot find ShareThis modal.');
    }

    this.$el.on('click.sharethis', (e) => {
      e.stopPropagation();
      this._toggle();
    });
  }

  _toggle() {
    if (this.isVisible) {
      this.$modal.off('.sharethis');
      $(window).off('.sharethis');
      this.isVisible = false;
      this.$modal.revealer('hide');
    } else {
      this.$modal.revealer('show', true);

      this._positionModal();

      this.$modal.revealer('hide', true);
      this.$modal.revealer('show');
      this.$modal.on('click.sharethis', e => e.stopPropagation());
      $(window).on('keydown.sharethis', (e) => {
        if (e.key === 'Escape') {
          this._toggle();
        }
      });
      $(window).on('click.sharethis', () => this._toggle());
      this.isVisible = true;
    }
  }

  _positionModal() {
    this.$modal.removeClass('sharethis-right-aligned');
    this.$modal.removeClass('sharethis-left-aligned');

    const rect = this.modal.getBoundingClientRect();
    let boundingLeft = 0;
    let boundingRight = (window.innerWidth || document.documentElement.clientWidth);

    if (this.boundingEl) {
      const boundElRect = this.boundingEl.getBoundingClientRect();

      boundingLeft = boundElRect.left;
      boundingRight = boundElRect.left + boundElRect.width;
    }

    if (rect.left < boundingLeft) {
      this.$modal.addClass('sharethis-left-aligned');
    } else if (rect.right > boundingRight) {
      this.$modal.addClass('sharethis-right-aligned');
    }
  }

  unload() {
    this.$el.off('.sharethis');
  }
}
